var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mb-2 hidden-md-and-down",on:{"click":function($event){$event.stopPropagation();return _vm.openFile(_vm.Mitgliederliste.file)}}},[_c('div',{staticClass:"kath-sz-card"},[_vm._v(" "+_vm._s(_vm.Mitgliederliste.name)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }